import styled from 'styled-components';

export const StyledEntrantThreeStep = styled.div`
  
  h3{
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 16px;
    font-weight: 500;
    color: #212529;
  }

  .body {
    margin: 32px 72px 0 72px;
  }
  
  .ant{
    &-alert-success{
      position: relative;
      background: rgba(81, 37, 143, 0.2);
	    border-radius: 0;
	    margin-bottom: 32px;
    }

    &-alert-content{
      p{
        margin-bottom: 0;
      }

      span{
        font-weight: 600;
      }
    }
  }

  .marks{
    border-radius: 8px;
    border: 1px solid #51258F;
    overflow: hidden;

    &__content{
      padding: 8px;

      & > .ant-col:not(:last-child){
        margin-bottom: 8px;
      }
    }

    &__header{
      background: rgba(81, 37, 143, 0.2);
      font-weight: 600;
      font-size: 10px;
      line-height: 16px;
      color: #2E384D;
    }

    &__item{
      display: flex;
      align-items: center;

      &:not(:last-child){
        margin-bottom: 8px;
      }

      span{
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
      }

      .ant-typography{
        margin-left: 8px;
      }
    }

    &__input{
      width: 100%;
      border-radius: 8px;
      text-align: center;

      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #2E384D;
    }

    &__footer{
      padding: 16px 0;
    }
  }
`